import { CABINET_COORDINATES, CABINET_NAME } from "../_data/constants";

function googleMapsEmbedUrl(): string {
  const { latitude, longitude } = CABINET_COORDINATES;
  const params = new URLSearchParams({
    q: `${latitude},${longitude}(Cabinet ${CABINET_NAME})`,
    z: "16",
    output: "embed",
  });
  return `https://maps.google.com/maps?${params.toString()}`;
}

export function googleMapsDirectionsUrl(): string {
  const { latitude, longitude } = CABINET_COORDINATES;
  const params = new URLSearchParams({
    api: "1",
    destination: `${latitude},${longitude}`,
    travelmode: "driving",
  });
  return `https://www.google.com/maps/dir/?${params.toString()}`;
}

export function MiniMap({
  className = "h-52 sm:h-64",
}: {
  className?: string;
}) {
  return (
    <div
      className={`relative overflow-hidden rounded-2xl bg-[var(--surface-2)] ring-1 ring-[var(--border-1)] ${className}`}
    >
      <iframe
        title={`Plan — Cabinet ${CABINET_NAME}`}
        src={googleMapsEmbedUrl()}
        className="absolute inset-0 size-full border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}
